{
  "familyId": "REK-CIJF-KEER",
  "questions": [
    {
      "id": "REK-CIJF-KEER-001",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 47 × 6",
      "options": [],
      "correctAnswer": "282",
      "data": {
        "acceptedAnswers": ["282"],
        "operand1": 47,
        "operand2": 6,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend vermenigvuldigen: per cijfer",
            "content": "Begin rechts: 7 × 6 = 42 → schrijf 2, onthoud 4. Dan: 4 × 6 = 24, plus 4 onthouden = 28. Antwoord: 282. Tip: werk altijd van rechts naar links en vergeet het 'onthouden' niet!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_2x1_onthouden",
      "variantIndex": 1,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.carry-forgotten", "label": "Vergeet het onthouden bij vermenigvuldigen" },
          { "id": "rek.carry-wrong-value", "label": "Schrijft een verkeerd onthoud-cijfer op" }
        ]
      },
      "feedback": {
        "explanationText": "47 × 6: begin rechts. Eenheden: 7 × 6 = 42 → schrijf 2, onthoud 4. Tientallen: 4 × 6 = 24, plus 4 onthouden = 28. Antwoord: 282. Werk altijd van rechts naar links en vergeet het 'onthouden' niet.",
        "solutionSteps": [
          "Eenheden: 7 × 6 = 42 → schrijf 2, onthoud 4",
          "Tientallen: 4 × 6 = 24 + 4 = 28",
          "Antwoord: 282"
        ]
      }
    },
    {
      "id": "REK-CIJF-KEER-002",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 83 × 7",
      "options": [],
      "correctAnswer": "581",
      "data": {
        "acceptedAnswers": ["581"],
        "operand1": 83,
        "operand2": 7,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap vermenigvuldigen",
            "content": "83 × 7: begin rechts. 3 × 7 = 21 → schrijf 1, onthoud 2. Dan: 8 × 7 = 56, plus 2 onthouden = 58. Antwoord: 581.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_2x1_basis",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.carry-forgotten", "label": "Vergeet het onthouden bij vermenigvuldigen" },
          { "id": "rek.carry-wrong-value", "label": "Schrijft een verkeerd onthoud-cijfer op" }
        ]
      },
      "feedback": {
        "explanationText": "83 × 7: begin rechts. Eenheden: 3 × 7 = 21 → schrijf 1, onthoud 2. Tientallen: 8 × 7 = 56, plus 2 onthouden = 58. Antwoord: 581.",
        "solutionSteps": [
          "Eenheden: 3 × 7 = 21 → schrijf 1, onthoud 2",
          "Tientallen: 8 × 7 = 56 + 2 = 58",
          "Antwoord: 581"
        ]
      }
    },
    {
      "id": "REK-CIJF-KEER-003",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 156 × 4",
      "options": [],
      "correctAnswer": "624",
      "data": {
        "acceptedAnswers": ["624"],
        "operand1": 156,
        "operand2": 4,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Driecijferig × eencijferig",
            "content": "156 × 4: begin rechts. 6 × 4 = 24 → schrijf 4, onthoud 2. 5 × 4 = 20, plus 2 = 22 → schrijf 2, onthoud 2. 1 × 4 = 4, plus 2 = 6. Antwoord: 624.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_3x1_onthouden",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.carry-forgotten", "label": "Vergeet het onthouden bij driecijferig × eencijferig" },
          { "id": "rek.carry-wrong-value", "label": "Schrijft een verkeerd onthoud-cijfer op" }
        ]
      },
      "feedback": {
        "explanationText": "156 × 4: begin rechts. Eenheden: 6 × 4 = 24 → schrijf 4, onthoud 2. Tientallen: 5 × 4 = 20 + 2 = 22 → schrijf 2, onthoud 2. Honderdtallen: 1 × 4 = 4 + 2 = 6. Antwoord: 624.",
        "solutionSteps": [
          "Eenheden: 6 × 4 = 24 → schrijf 4, onthoud 2",
          "Tientallen: 5 × 4 = 20 + 2 = 22 → schrijf 2, onthoud 2",
          "Honderdtallen: 1 × 4 = 4 + 2 = 6",
          "Antwoord: 624"
        ]
      }
    },
    {
      "id": "REK-CIJF-KEER-004",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 209 × 3",
      "options": [],
      "correctAnswer": "627",
      "data": {
        "acceptedAnswers": ["627"],
        "operand1": 209,
        "operand2": 3,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Let op de nul!",
            "content": "209 × 3: begin rechts. 9 × 3 = 27 → schrijf 7, onthoud 2. 0 × 3 = 0, plus 2 = 2. 2 × 3 = 6. Antwoord: 627. Let op: 0 × 3 = 0, maar vergeet het onthouden niet!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_met_nul",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.multiplication-error", "label": "Behandelt 0 × n verkeerd (vergeet of het onthouden meetelt)" },
          { "id": "rek.carry-forgotten", "label": "Vergeet het onthouden bij 0 in het midden" }
        ]
      },
      "feedback": {
        "explanationText": "209 × 3: begin rechts. 9 × 3 = 27 → schrijf 7, onthoud 2. 0 × 3 = 0, plus 2 onthouden = 2. 2 × 3 = 6. Antwoord: 627. De nul in het midden is een veelgemaakte fout — 0 × 3 = 0, maar het onthouden telt wél mee!",
        "solutionSteps": [
          "Eenheden: 9 × 3 = 27 → schrijf 7, onthoud 2",
          "Tientallen: 0 × 3 = 0 + 2 = 2",
          "Honderdtallen: 2 × 3 = 6",
          "Antwoord: 627"
        ]
      }
    },
    {
      "id": "REK-CIJF-KEER-005",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Een bakker bakt 8 bakplaten met elk 36 koekjes. Hoeveel koekjes bakt hij in totaal? Reken cijferend uit.",
      "options": [],
      "correctAnswer": "288",
      "data": {
        "acceptedAnswers": ["288"],
        "operand1": 36,
        "operand2": 8,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend vermenigvuldigen in context",
            "content": "36 × 8: begin rechts. 6 × 8 = 48 → schrijf 8, onthoud 4. 3 × 8 = 24, plus 4 = 28. Antwoord: 288 koekjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_context",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.carry-forgotten", "label": "Vergeet het onthouden bij contextopgave" },
          { "id": "rek.carry-wrong-value", "label": "Schrijft een verkeerd onthoud-cijfer op" }
        ]
      },
      "feedback": {
        "explanationText": "36 × 8 = 288. Cijferend: 6 × 8 = 48 → schrijf 8, onthoud 4. 3 × 8 = 24 + 4 = 28. De bakker bakt 288 koekjes. Bij contextopgaven: herken eerst welke bewerking je nodig hebt (hier: vermenigvuldigen).",
        "solutionSteps": [
          "Herken: 8 bakplaten × 36 koekjes = 36 × 8",
          "Eenheden: 6 × 8 = 48 → schrijf 8, onthoud 4",
          "Tientallen: 3 × 8 = 24 + 4 = 28",
          "Antwoord: 288 koekjes"
        ]
      }
    },
    {
      "id": "REK-CIJF-KEER-006",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 24 × 13",
      "options": [],
      "correctAnswer": "312",
      "data": {
        "acceptedAnswers": ["312"],
        "operand1": 24,
        "operand2": 13,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met tientallen",
            "content": "24 × 13: Eerst 3 × 24 = 72. Dan 10 × 24 = 240 (vergeet de nul niet!). Tel op: 72 + 240 = 312.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_2x2_basis",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.multiplication-zero-placeholder", "label": "Vergeet de 0 als placeholder bij tientallen-rij" },
          { "id": "rek.partial-calculation", "label": "Berekent maar één partieel product (vergeet er een)" }
        ]
      },
      "feedback": {
        "explanationText": "24 × 13: Eerst de eenheden: 3 × 24 = 72. Dan de tientallen: zet eerst een 0 op, dan 1 × 24 = 24. Dus 240. Tel op: 72 + 240 = 312.",
        "solutionSteps": [
          "3 × 24 = 72",
          "10 × 24 = 240 (vergeet de 0 niet!)",
          "72 + 240 = 312"
        ]
      }
    },
    {
      "id": "REK-CIJF-KEER-007",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 125 × 14",
      "options": [],
      "correctAnswer": "1750",
      "data": {
        "acceptedAnswers": ["1750", "1.750"],
        "operand1": 125,
        "operand2": 14,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Driecijferig × tweecijferig",
            "content": "125 × 14: Eerst 4 × 125 = 500. Dan 10 × 125 = 1.250 (denk aan de nul!). Tel op: 500 + 1.250 = 1.750.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_3x2_basis",
      "variantIndex": 7,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.multiplication-zero-placeholder", "label": "Vergeet de 0 als placeholder bij tientallen-rij" },
          { "id": "rek.partial-calculation", "label": "Berekent maar één partieel product (vergeet er een)" }
        ]
      },
      "feedback": {
        "explanationText": "125 × 14: Eerst 4 × 125 = 500. Dan de tientallen: schrijf een 0, dan 1 × 125 = 125. Dat is 1.250. Tel op: 500 + 1.250 = 1.750.",
        "solutionSteps": [
          "4 × 125 = 500",
          "10 × 125 = 1.250",
          "500 + 1.250 = 1.750"
        ]
      }
    },
    {
      "id": "REK-CIJF-KEER-008",
      "familyId": "REK-CIJF-KEER",
      "module": "Basisrekenen",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_vermenigvuldigen",
      "questionType": "cijferend_rekenen",
      "question": "Voor een schoolreisje zijn er 12 bussen gehuurd. In elke bus passen 45 kinderen. Hoeveel kinderen kunnen er in totaal mee?",
      "options": [],
      "correctAnswer": "540",
      "data": {
        "acceptedAnswers": ["540"],
        "operand1": 45,
        "operand2": 12,
        "operation": "×"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Context: vermenigvuldigen",
            "content": "12 bussen × 45 kinderen = 45 × 12. Eerst 2 × 45 = 90. Dan 10 × 45 = 450. Tel op: 90 + 450 = 540.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijf_keer_context_2x2",
      "variantIndex": 8,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.80,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.multiplication-zero-placeholder", "label": "Vergeet de 0 als placeholder bij tientallen-rij" },
          { "id": "rek.partial-calculation", "label": "Berekent maar één partieel product (vergeet er een)" }
        ]
      },
      "feedback": {
        "explanationText": "12 bussen met elk 45 kinderen is 12 × 45. Cijferend: 2 × 45 = 90. Dan 10 × 45 = 450. Tel op: 90 + 450 = 540 kinderen.",
        "solutionSteps": [
          "Herken: 12 × 45",
          "2 × 45 = 90",
          "10 × 45 = 450",
          "90 + 450 = 540"
        ]
      }
    }
  ]
}